<template>
    <section class="m-4">
        <div v-if="loaded">
            <div class="border-t border-gray-dark">
                <div class="mt-4 rounded-md w-full mx-auto">
                    <div class="flex items-center px-3 py-6">
                        <div class="mr-3 flex-1">
                            <h3 class="text-lg font-bold">
                                Autopilot
                                <span class="text-white text-xs px-1 py-1 rounded-md" :class="autopilot.is_on ? 'bg-primary' : 'bg-destructive'">
                                    {{ this.autopilot.is_on ? 'Active' : 'Inactive'}}
                                </span>
                            </h3>
                            <p class="text-gray-darker text-sm">To maximize your earnings, we can send invites on your behalf to people who matches your defined criteria.</p>
                        </div>
                        <p-check class="p-switch p-fill" color="primary" v-model="autopilot.is_on" @change="update"></p-check>
                    </div>
                    <div class="flex flex-wrap items-center px-6 pb-3 -mt-3 bg-gray-light rounded-md">
                        <div class="w-full mx-auto">            
                            <div class="my-4 w-full">
                                <label for="threshold" class="font-bold block">Limit only to those people to whom I've sent atleast these many emails before</label>
                                <input type="number" name="threshold" id="threshold" class="my-1 border border-gray-dark border-b-2 p-2 rounded" placeholder="10" v-model="autopilot.threshold">
                                <p class="text-destructive" v-if="errors['threshold'] && errors['threshold'].length > 0">{{ this.errors['threshold'][0] }}</p>
                            </div>

                            <div class="my-4 w-full">
                                <label for="invites-per-day" class="font-bold block">Limit the number of invites sent per day to this number</label>
                                <input type="number" name="invites-per-day" id="invites-per-day" class="my-1 border border-gray-dark border-b-2 p-2 rounded" placeholder="10" v-model="autopilot.invites_per_day">
                                <p class="text-destructive" v-if="errors['invites_per_day'] && errors['invites_per_day'].length > 0">{{ this.errors['invites_per_day'][0] }}</p>
                            </div>

                            <div class="my-4 w-full">
                                <label for="approximate-earnings" class="font-bold block">Expected Earnings</label>
                                <p id="approximate-earnings">
                                    ~ ${{ this.expectedEarnings }}/month recurring annually
                                    <span class="text-sm text-gray-darker">based on our average conversion rate</span>
                                </p>
                            </div>

                            <div class="my-4 w-full">
                                <label for="message" class="font-bold">Invitation</label>
                                <textarea name="message" id="message" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full h-64" placeholder="Tell them why you want them to use Mailman?" v-model="autopilot.message">
                                </textarea>
                                <p class="text-destructive" v-if="errors['message'] && errors['message'].length > 0">{{ this.errors['message'][0] }}</p>
                            </div>
                        </div>
                        <progressable-button
                            type="submit"
                            class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                            :loading="loading"
                            state="Saving..."
                            @click.native="update"
                        >
                            Save changes
                        </progressable-button>
                    </div>
                </div>
            </div>    
        </div>
        <div v-else>
            <loading />
        </div>
    </section>  
</template>

<script>
export default {
    data() {
        return {
            loaded: false,
            loading: false,
            annual_commission: 30,
            invite_to_trial_rate: 10,
            trial_to_paying_rate: 23,
            errors: {},
            autopilot: {
                is_on: false,
                threshold: 10,
                invites_per_day: 6,
                message: 
`I'm excited to share an invite to Mailman – the easiest way to keep your inbox under control.

I love the product, and think you will too! It saves me 100+ hours per year.

Just sign up here and you'll be taken care of, I promise:
{your_ambassador_link}

I've CC'ed their CEO Mohit to help :)`,
            },
        }
    },
    computed: {
        expectedEarnings() {
            return Math.round(this.annual_commission
                    * this.autopilot.invites_per_day * 30
                    * 1/(this.autopilot.threshold / 100) * 0.1 // weight of this factor = 0.1
                    * (this.invite_to_trial_rate / 100)
                    * (this.trial_to_paying_rate / 100));
        }
    },
    mounted() {
        axios.get('/api/ambassador/tools/autopilot')
            .then(response => {
                // If the autopilot JSON is received, we'll set values from that,
                // otherwise, we'll not do anything.
                if (response.data.state) {
                    this.autopilot.is_on = response.data.state === 'on' ? true : false;
                    this.autopilot.threshold = response.data.threshold;
                    this.autopilot.invites_per_day = response.data.invites_per_day;
                    this.autopilot.message = response.data.message;
                }
                this.loaded = true;
            })
            .catch(console.error);
    },
    methods: {
        update() {
            this.loading = true;
            this.errors = {};
            axios.put('/api/ambassador/tools/autopilot', {
                state          : this.autopilot.is_on ? 'on' : 'off',
                threshold      : this.autopilot.threshold,
                invites_per_day: this.autopilot.invites_per_day,
                message        : this.autopilot.message,
            })
            .then(response => {
                Event.$emit('toast', {text: 'Autopilot settings successfully saved!'});
            }).catch(error => {
                this.errors = error.response.data.errors;
            }).then(() => {
                this.loading = false;
            });
        }
    }
}
</script>